import * as $ from 'jquery'
import store from './store'
import {scrollTo} from './scrollTo';

const tabClick = (function($this, item, href = null) {

  if(typeof(item) === 'undefined' || !document.getElementById(item)) {
    window.location.href = href;
    return false;
  }

  const $container = $($this).closest('.tab'),
        $select    = $container.find('.tab__select'),
        $item      = $('#'+item),
        anim       = $container.attr('data-tab-anim') || 'slide',
        is_active  = $item.hasClass('active');

  $container.find('.tab__link.active').removeClass('active');

  if(anim === 'slide') {
    $container.find('.tab__item.active').add($item).slideUp(333, function() {
      $(this).removeClass('active');
    });
  } else {
    $container.find('.tab__item.active').hide().removeClass('active');
  }

  if(!is_active) {
    $container.find('.tab__link[data-tab="'+item+'"]').addClass('active')

    if(anim === 'slide') {
      $item.slideDown(333,function() {
        $(this).addClass('active');

        if(store.breakpoints.active.indexOf('small-down') !== -1) {
          scrollTo($this);
        }
      });
    } else {
      $item.show().addClass('active');
    }

    $select.val(item);
    $item.trigger('accordion-show');
  }

  $item.trigger('accordion-change');
});

const tabLinkClick = (function(e) {
  e.preventDefault();

  const $this = this,
         href = $this.href,
         item = $this.getAttribute('data-tab');

  tabClick($this, item, href);
});

const tabLinkChange = (function(e) {
  e.preventDefault();

  const $this = this,
        $option  = $this.options[$this.selectedIndex],
        item     = $option.value,
        href     = $option.getAttribute('data-url');

  tabClick($this, item, href);
});

store.$app.find('.tab').each(function() {
  const $this = $(this),
        query = $this.attr('data-active') || null;

  var active = $this.data('is-active') || false;

  if(query) {
    store.$app.on('breakpoint-change', () => {

      if(store.breakpoints.active.indexOf(query) !== -1) {

        if(!active) {

          $this.on('click','.tab__link', tabLinkClick);
          $this.find('.tab__select').on('change', tabLinkChange);
          $this.find('.tab__item:not(.active)').hide();

          active = true;

        }

      } else {

        $this.off('click','.tab__link', tabLinkClick);
        $this.find('.tab__select').off('change', tabLinkChange);

        $this.find('.tab__item').show();

        active = false;

      }
    });
  } else {
    $this.on('click','.tab__link', tabLinkClick);
    $this.find('.tab__select').on('change', tabLinkChange);
  }
});
